module.exports = "/static/img/where_01.png?7061c79641e53040b7ec49610455ad09";